import DragScroll from 'src/componentes/dragscroll';

import { BOW_TIE_SIDE } from '../constants';
import { flattenBranches } from '../utils';
import BowTieBranch from './BowTieBranch';
import BowTieLegend from './BowTieLegend';

const diagramSide =
  'tw:relative tw:flex tw:min-h-45 tw:flex-col tw:justify-center tw:gap-5.5 tw:self-stretch tw:not-empty:before:absolute tw:not-empty:before:top-1/2 tw:not-empty:before:h-px tw:not-empty:before:w-7 tw:not-empty:before:bg-[#dfe7ef]';

function BowTieDiagram({ values, disabled, onControlClick }) {
  const causas = flattenBranches(values?.causas, 'causas');
  const consequencias = flattenBranches(values?.consequencias, 'consequencias');
  const nomeRisco = values?.nome ?? '';

  return (
    <div className="tw:text-gray-800">
      <BowTieLegend />

      <DragScroll overflow="auto" height="auto" width="100%">
        <div className="tw:grid tw:w-max tw:min-w-full tw:grid-cols-[500px_170px_500px] tw:items-center tw:gap-7 tw:px-1 tw:py-2.5 tw:min-[768px]:px-2.5">
          <div
            className={`${diagramSide} tw:pr-4.5 tw:not-empty:before:-right-7`}
          >
            {causas.map((cause, index) => (
              <BowTieBranch
                key={`${BOW_TIE_SIDE.PREVENTIVO}-${cause?.id ?? index}`}
                branch={cause}
                side={BOW_TIE_SIDE.PREVENTIVO}
                index={index}
                disabled={disabled}
                onControlClick={onControlClick}
              />
            ))}
          </div>

          <div
            className="tw:relative tw:z-1 tw:flex tw:min-h-32.5 tw:items-center tw:justify-center tw:rounded-[10px] tw:bg-[#dc3545] tw:p-4 tw:text-center tw:text-[13px]/[1.4] tw:font-bold tw:text-white tw:shadow-[0_6px_14px_rgba(31,41,55,0.14)]"
            title={nomeRisco}
          >
            {nomeRisco}
          </div>

          <div
            className={`${diagramSide} tw:pl-4.5 tw:not-empty:before:-left-7`}
          >
            {consequencias.map((consequence, index) => (
              <BowTieBranch
                key={`${BOW_TIE_SIDE.CORRETIVO}-${consequence?.id ?? index}`}
                branch={consequence}
                side={BOW_TIE_SIDE.CORRETIVO}
                index={index}
                disabled={disabled}
                onControlClick={onControlClick}
              />
            ))}
          </div>
        </div>
      </DragScroll>
    </div>
  );
}

export default BowTieDiagram;
